import httpClient from "@plugins/http";
import type {
  FeatureFlagModel,
  FeatureFlagName,
  FeatureFlagRuleCreateModel,
  FeatureFlagRuleDeleteRuleModel,
  FeatureFlagRuleModel,
  FeatureFlagToggleRequestModel,
} from "@modules/feature-flag/feature-flag-types.ts";
import type { ApiResponse } from "@apis/api.ts";

/**
 * Fetch enabled features
 */
export const fetchEnabledFeatures = (): Promise<ApiResponse<FeatureFlagName[]>> => {
  return httpClient.get(`/apis/feature-flag/list`);
};

/**
 * Fetch all manageable feature flags and their rules.
 */
export const fetchManageableFeatureFlags = async (): Promise<ApiResponse<FeatureFlagModel[]>> => {
  return await httpClient.get(`/apis/feature-flag/manage/list`);
};

/**
 * Toggle the enabled state of a feature flag by its UUID.
 * @param requestModel as FeatureFlagToggleRequestModel
 */
export const toggleFeatureFlagState = async (
  requestModel: FeatureFlagToggleRequestModel,
): Promise<ApiResponse<boolean>> => {
  return await httpClient.post(`/apis/feature-flag/toggle`, requestModel);
};

/**
 * Create feature flag's rule(s).
 * @param requestModel as FeatureFlagRuleCreateModel
 */
export const createFeatureFlagRules = async (
  requestModel: FeatureFlagRuleCreateModel,
): Promise<ApiResponse<FeatureFlagRuleModel[]>> => {
  return await httpClient.post("/apis/feature-flag/rule/create", requestModel);
};

/**
 * Delete feature flag's rule(s).
 * @param requestModel as FeatureFlagRuleDeleteRuleModel
 */
export const deleteFeatureFlagRules = async (
  requestModel: FeatureFlagRuleDeleteRuleModel,
): Promise<ApiResponse<FeatureFlagRuleModel[]>> => {
  return await httpClient.post("/apis/feature-flag/rule/delete", requestModel);
};
